/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRs from '@appbaseio/reactivesearch-vue'
import './simple-sidebar.css'
import VModal from 'vue-js-modal'
import BookPanel from './components/BookPanel'
import BookDisplay from './components/BookDisplayPanel'
import VueGtm from 'vue-gtm'
import VueAnalytics from 'vue-analytics'
import MyPlugin from './plugins/myplugin'
import 'babel-polyfill'


Vue.use(VModal, { dialog: true })
Vue.use(VueRs)
Vue.use(MyPlugin)

Vue.config.productionTip = false

Vue.use(VueGtm, {
  id: 'GTM-T76TMVK', //or ['GTM-xxxxxxx', 'GTM-xxxxxxx'], // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
  //ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
});

// Config Google Analytics
// Vue.use(VueAnalytics, {
//   id: 'UA-140966232-5',
//   router
// })

Vue.component('book-panel', BookPanel)
Vue.component('book-display-panel',BookDisplay)

import cookie from 'vue-cookie'
Vue.prototype.$cookie = cookie; // when configuring, the name here is not defined as a cookie.

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',

  created: function () {// create time node

  }

})

$(document).ready(function() {
  $("#menu-toggle").click(function(e) {
    e.preventDefault();
    $("#wrapper").toggleClass("toggled");
  });
})
